<template>
    <div>
        <b-form @submit="assignUser" class="assing-user-form">
            <v-select v-model="pmName" required placeholder="Unit manager name" label="unitManagerName" :options="pmNameOptions"></v-select>
            <v-select v-model="jira_project_name" required placeholder="Jira Project name" label="name" :options="options"></v-select>

            <b-button type="submit" variant="primary">Create Project</b-button>
        </b-form>
    </div>

</template>

<script>
export default {
  name: 'AssignUser',
  data () {
    return {
      pmName: '',
      jira_project_name: '',
      options: [],
      pmNameOptions: []
    }
  },
  created () {
    this.axios({
      method: 'post',
      url: '/api/users',
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    })
      .then(response => {
        var list = []
        response.data.filter(function (value, key) {
          list.push(value.name)
        })
        this.pmNameOptions = list
      })
      .catch(err => {
        console.log(err)
      })
  },
  mounted () {
    this.axios({
      method: 'get',
      url: '/api/jiraProjects',
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    })
      .then(response => {
        var list = []
        var project
        response.data.filter(function (value, key) {
          project = {
            name: value.name,
            key: value.key
          }
          list.push(project)
        })
        this.options = list
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    assignUser (e) {
      e.preventDefault()
      this.axios
        .post('/api/create', {
          unit_manager_name: this.pmName,
          jira_project_name: this.jira_project_name

        }, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          console.log(response)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

    .assing-user-form{
        width: 400px;
        margin: 20px 0;
    }
    .assing-user-form input{
        margin-bottom: 20px;
    }

</style>
